export default function HeroSection() {
  return (
    <section className="relative min-h-[620px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#C7510F] via-[#B8450A] to-[#2D2D2D]"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/10 to-transparent"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20 text-center">
        <div className="max-w-4xl mx-auto">
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-amber-200/80 mb-4">
            REGISTERED U.S. DEPARTMENT OF STATE COURIER
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Need a Passport Urgently? We Can Help.
          </h1>

          <p className="text-base md:text-lg text-amber-50/90 max-w-3xl mx-auto mb-10 leading-relaxed">
            If your trip is coming up and your passport situation isn't sorted, you're in the right place. Fast Passport Center is a registered State Dept courier with daily reserved access to federal passport agencies — getting urgent passports processed in as little as 3 business days for over 20 years.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-[#F59E0B] hover:bg-[#D97706] text-[#2D2D2D] font-bold text-base md:text-lg rounded-md transition-colors cursor-pointer"
            >
              <i className="ri-passport-line text-xl"></i>
              Start My Urgent Passport
            </a>
            <a
              href="tel:8772530084"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 border-2 border-white/40 hover:border-white hover:bg-white/10 text-white font-semibold text-base md:text-lg rounded-md transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill text-xl"></i>
              Call 877-253-0084
            </a>
          </div>

          <p className="text-sm md:text-base text-amber-100/70 mb-10 max-w-2xl mx-auto">
            Most urgent passport situations are more solvable than you think. Tell us your travel date and we'll tell you exactly what's possible.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-white/75 text-xs md:text-sm">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-government-fill"></i> Registered State Dept. Courier
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-calendar-check-line"></i> Daily Reserved Agency Access
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-timer-flash-line"></i> Processing from 3 Business Days
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-shield-check-line"></i> A+ BBB Accredited
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-history-line"></i> 20+ Years Solving Urgent Situations
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}